export default "__VITE_ASSET__bRgtMoPh__"